document.addEventListener('DOMContentLoaded', function() {
  // Settings'den yönlendirmeleri al
  const searchRedirects = JSON.parse(document.querySelector('#search-redirects-data').textContent || '{}');
  console.log('Loaded redirects:', searchRedirects);
  
  const searchForm = document.querySelector('form.search-bar--page') || 
                    document.querySelector('form[action="/search"]');
                    
  if (!searchForm) {
    console.log('Arama formu bulunamadı');
    return;
  }

  const searchInput = searchForm.querySelector('input[name="q"]');

  if (!searchInput) {
    console.log('Arama input alanı bulunamadı');
    return;
  }

  searchForm.addEventListener('submit', function(e) {
    const searchTerm = searchInput.value.toLowerCase().trim();
    console.log('Aranan terim:', searchTerm);

    if (searchRedirects[searchTerm]) {
      e.preventDefault();
      window.location.href = searchRedirects[searchTerm];
    }
  });

  searchInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      const searchTerm = this.value.toLowerCase().trim();
      
      if (searchRedirects[searchTerm]) {
        e.preventDefault();
        window.location.href = searchRedirects[searchTerm];
      }
    }
  });
});